export const cancelModalTestId = 'cancel-modal-test-id';
export const cancelButtonTestId = 'noButton';
export const acceptButtonTestId = 'yesButton';
export const modalIconTestId = 'cancel-modal-icon-test-id';
export const modalTextContainerTestId = 'cancel-modal-text-container-test-id';
export const cancelModalTextContent =
  'If you cancel now all data will be lost. Are you sure you want to leave?';
export const testingProps = { visible: true };
